require('../../modules/es7.object.to-array');
module.exports = require('../../modules/$').core.Object.values;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/fn/object/values.js
 ** module id = 649
 ** module chunks = 1
 **/